import { styled } from "@mui/material/styles";
import CustomFieldSubtitle from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomFieldSubtitle";

export const StyledCustomFieldSubtitle = styled(CustomFieldSubtitle, {
  shouldForwardProp: (prop: string) => !["level"].includes(prop),
})<{ level: number }>(({ level }) => ({
  marginLeft: `${level * 16}px`,
}));
